// initial state
import * as base from './base.js'
const baseName = '/admin/largeScreen'

const largeCurMonthRepair = baseName + '/curMonthRepair' //大屏监控--当月报修统计
const largeTodayWork = baseName + '/todayWork' //大屏监控--当日报修统计
const largeTotalProcessWork = baseName + '/totalProcessWork' //大屏监控--累计处理中工单统计
const largeCurYearData = baseName + '/curYearData' //大屏监控--累计处理中工单统计
const largeWork = baseName + '/work' //大屏监控--累计处理中工单统计

const obj = base.setBaseUrl('', baseName)

const a = Object.assign(obj, { largeCurMonthRepair, largeTodayWork, largeTotalProcessWork, largeCurYearData, largeWork })
export default a
